import { Button, ButtonGroup, Grid } from "@material-ui/core";
import React from "react";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable, { RowItemTypes } from "../../../components/table/Table";
import ScrollableTabs from "../../../components/tabs/Tabs";
import { DeleteModal } from "../../../containers/delete-modal/DeleteModal";
import { getIcon } from "../../../icon/icon";
import { getGroups, getGroupsWithIds } from "../../../state/actions/GroupActions";
// Actions
import { getMustSellSku, removeMustSellSkus, updateMustSellSku } from "../../../state/actions/MustSellActions";
import { getProductsForIds } from "../../../state/actions/ProductActions";
import styles from "./ViewMustSellPage.module.scss";
import GenericPickerModal from "../../../containers/generic-picker-modal/GenericPickerModal";
import HelpCard from "../../../components/help-card/HelpCard";
import { withTranslation } from "react-i18next";
import { MustSellUOMTypes } from "../../../state/constants/MustSellUOMTypes";

var mustSellSkuId = "";

class ViewMustSellPage extends React.Component {
  constructor() {
    super();

    this.state = {
      loadingMustSells: false,
      loadingMustSellsProductGroups: false,
      mustSellProductGroups: [],
      addProductGroupModalOpen: false,
      deleteAlertShowing: false,
      deleteSKUAlertShowing: false,
      mustSell: {},
      selectedItems: [],
      isEditing: false,

      editedMustSell: {}
    };
  }

  componentDidMount() {
    this.setState({
      loadingMustSells: true,
      loadingMustSellsProductGroups: true
    });

    mustSellSkuId = this.props.match.params.mustSellSkuId;

    this.props.getMustSellSku(mustSellSkuId, () => {
      this.setState({ loadingMustSells: false, mustSell: this.props.mustSell, editedMustSell: this.props.mustSell });

      var productGroupIds =
        this.props.mustSell.ProductGroups !== undefined
          ? this.props.mustSell.ProductGroups.map(group => group.ProductGroupId)
          : [];

      this.props.getGroupsWithIds(productGroupIds, () => {
        this.setState({ loadingMustSellsProductGroups: false });
      });
    });
  }

  addProductGroupsToMustSellSku(itemsToAdd) {
    const mustSell = Object.assign({}, this.state.editedMustSell)

    const productGroups = itemsToAdd.map(item => {
      return {
        ProductGroupId: item,
        Sequence: 1,
        MustSellThreshold: 0,
        MustSellUOM: MustSellUOMTypes().EACHES.key
      }
    })
    productGroups.forEach(group => {
      mustSell.ProductGroups.push(group)
    });

    this.setState({ editedMustSell: mustSell, addProductGroupModalOpen: false });
  }

  removeProdcutGroupsFromMustSellSku(itemsToRemove) {
    const mustSell = Object.assign({}, this.state.editedMustSell)

    const productGroups = mustSell.ProductGroups.filter(item => !itemsToRemove.map(value => value.id).includes(item.ProductGroupId));

    mustSell.ProductGroups = productGroups

    this.setState({ editedMustSell: mustSell, deleteAlertShowing: false, selectedItems: [] });
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.props.mustSell) !==
      JSON.stringify(this.state.mustSell)
    ) {
      this.setState({ mustSell: this.props.mustSell, editedMustSell: this.props.mustSell });
    }
  }

  createData(mustSellProductGroups) {
    if (mustSellProductGroups) {
      let data = [];

      mustSellProductGroups.forEach(mustSellProductGroup => {
        let product = this.props.groups[mustSellProductGroup.ProductGroupId];

        if (product !== undefined) {
          data.push({ id: product.id, name: product.Name, sequence: mustSellProductGroup.Sequence, threshold: mustSellProductGroup.MustSellThreshold, uom: mustSellProductGroup.MustSellUOM });
        }
      });

      return data;
    }

    return []
  }

  createHeaders() {
    return [
      {
        id: "sequence",
        clickable: false,
        align: "left",
        label: this.props.t('must-sell.must-sell-sequence'),
        type: RowItemTypes.TEXT_FIELD,
        change: { identifier: "Sequence" }
      },
      {
        id: "name",
        clickable: true,
        action: { path: "/product-groupings/{id}", identifier: "id" },
        align: "left",
        label: this.props.t('must-sell.must-sell-name')
      },
      {
        id: "id",
        clickable: false,
        align: "left",
        label: this.props.t('must-sell.id')
      },
      {
        id: "threshold",
        clickable: false,
        align: "left",
        label: this.props.t('must-sell.must-sell-threshold'),
        type: RowItemTypes.TEXT_FIELD,
        change: { identifier: "MustSellThreshold" }
      },
      {
        id: "uom",
        clickable: false,
        align: "left",
        label: this.props.t('must-sell.must-sell-uom'),
        type: RowItemTypes.DROPDOWN,
        change: { identifier: "MustSellUOM" },
        typeData: Object.values(MustSellUOMTypes())
      },
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = {};

      cell.id = header.id;

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      if (header.hasOwnProperty("change")) {
        cell.onChange = (data, row) => {
          let mustSell = Object.assign({}, this.state.editedMustSell);

          const index = mustSell.ProductGroups.findIndex(group => group.ProductGroupId === row.id);

          mustSell.ProductGroups[index][header.change.identifier] = data

          this.setState({
            editedMustSell: mustSell
          })
        }
      }

      cell.align = header.align;
      cell.clickable = header.clickable;
      cell.type = header.type;
      cell.typeData = header.typeData

      cells.push(cell);
    });

    return cells;
  }

  renderData() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    if (this.createData(this.state.editedMustSell.ProductGroups).length === 0) {
      return (
        <PagePlaceholder
          image={getIcon("diamond.svg")}
          text={this.props.t('product-group.none-attached')}
        />
      );
    } else {
      return (
        <SimpleTable
          isEditing={this.state.isEditing}
          isOrdered
          handleSelection={selectedIds => {
            this.setState({ selectedItems: selectedIds });
          }}
          isSelectable={true}
          dataId={"id"}
          cells={cells}
          headers={headers}
          rows={this.createData(this.state.editedMustSell.ProductGroups)}
          selected={this.state.selectedItems}
        />
      );
    }
  }

  generateDeletedItems() {
    let deletedItems = [];

    this.state.selectedItems.forEach((selectedItemId) => {
      const group = this.props.groups[selectedItemId];

      if (group !== undefined) {
        deletedItems.push({ id: group.id, name: group.Name });
      }
    });

    return deletedItems;
  }

  deleteSKU() {
    this.props.removeMustSellSkus([mustSellSkuId], () => {
      this.setState({
        deleteSKUAlertShowing: false,
        selectedItems: []
      });
      this.props.history.push("/must-sell-skus")
    });
  }

  handleEdit() {
    if (this.state.isEditing) {
      this.setState({ loadingMustSellsProductGroups: true })
      this.props.updateMustSellSku(this.state.editedMustSell, () => {
        this.setState({ loadingMustSellsProductGroups: false })
      })
    }
    this.setState({ isEditing: !this.state.isEditing })
  }

  render() {
    const mustSellSkuId = this.props.match.params.mustSellSkuId;
    const content = this.renderData();

    return (
      <div>
        <BreadcrumbsItem to={`/routes/${mustSellSkuId}`}>Route</BreadcrumbsItem>

        <GenericPickerModal
          handleCancel={() => this.setState({ addProductGroupModalOpen: false })}
          handleDone={selectedProducts => this.addProductGroupsToMustSellSku(selectedProducts)}
          open={this.state.addProductGroupModalOpen}
          selected={this.state.editedMustSell.ProductGroupIds}
          handleSelection={() => { }}
          getAllData={(callback) => this.props.getGroups(callback)}
          searchTitle={this.props.t('product-group.search')}
          title={this.props.t('product-group.product-groups')}
          data={Object.values(this.props.groups)}
          idField="id"
          valueField="Name"
        />

        <DeleteModal
          handleCancel={() => {
            this.setState({
              deleteAlertShowing: false,
              selectedItems: []
            });
          }}
          handleDone={data => {
            this.removeProdcutGroupsFromMustSellSku(data)
          }}
          data={this.generateDeletedItems()}
          open={this.state.deleteAlertShowing}
        />

        <AlertDialog
          title={this.props.t('must-sell.remove-question')}
          description={this.props.t('common.remove-description')}
          options={[
            {
              label: this.props.t('common.cancel'),
              action: () => this.setState({ deleteSKUAlertShowing: false })
            },
            { label: this.props.t('common.delete'), action: () => this.deleteSKU() }
          ]}
          isOpen={this.state.deleteSKUAlertShowing}
        />

        {this.state.loadingMustSells ? (
          <Loading />
        ) : (
            <div>
              <HeaderBlock
                title={this.state.mustSell.Name}
                right={
                  <Grid container spacing={2} alignItems="center" justify="flex-end">
                    <Grid item>
                      {this.state.isEditing &&

                        <ButtonGroup classes={{ root: styles.buttonGroup }}>
                          <Button
                            onClick={() => this.setState({ deleteSKUAlertShowing: true })}
                            variant="outlined"
                            color="primary"
                          >
                            {this.props.t('common.delete-all')}
                          </Button>
                        </ButtonGroup>}
                      <ButtonGroup classes={{ root: styles.buttonGroup }}>
                        <Button
                          disabled={this.state.selectedItems.length === 0}
                          onClick={() => this.setState({ deleteAlertShowing: true })}
                          variant="outlined"
                          color="primary"
                        >
                          {this.props.t('common.delete-selected')}
                        </Button>
                        <Button
                          disabled={!this.state.isEditing}
                          onClick={() =>
                            this.setState({ addProductGroupModalOpen: true })
                          }
                          variant="outlined"
                          color="secondary"
                        >
                          {this.props.t('product-group.add-product-group')}
                        </Button>
                        <Button
                          onClick={() => this.handleEdit()}
                          variant="outlined"
                          color="secondary"
                        >
                          {this.state.isEditing ? this.props.t('common.save') : this.props.t('common.edit')}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                }
              />
              <HelpCard
                message={this.props.t('must-sell.threshold-helper')}
              />
              <PageContainer hasHelp hasFooter>
                {
                  this.state.loadingMustSellsProductGroups ? <Loading /> :
                    <ScrollableTabs
                      tabs={[
                        {
                          name: this.props.t('product-group.product-groups'),
                          content: content
                        }
                      ]}
                    />
                }
              </PageContainer>
            </div>
          )}
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { mustSell, mustSellProductGroups } = state.MustSellReducer;
  const { groups } = state.GroupReducer;
  return { mustSell, mustSellProductGroups, groups };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getMustSellSku,
      getGroupsWithIds,
      getProductsForIds,
      updateMustSellSku,
      removeMustSellSkus,
      getGroups
    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ViewMustSellPage))
);

// EXPORT COMPONENT

export { hoc as ViewMustSellPage };

